import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  normalizeAndMergeEntity,
  normalizeAndRemoveEntities,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { stageActions, stageStudyActions } from '@core/actions/stage.actions';
import { studyOutgoingDtoSchema } from '@core/services/stage/review-effects';
import { createReducer, on } from '@ngrx/store';
import { IAnnotation } from '@core/state/entities/annotation/annotation.entity';
import { entityKey } from '../entity-name-map';

export const annotationEntityReducer = createReducer(
  defaultEntityState<IAnnotation>(),
  on(stageActions.updateSession, (state, props) =>
    mergeEntityState(entityKey.annotations, state, props, (an) => {
      const session = props.entities.sessions?.[props.sessionId];
      return (
        an.studyId === session?.studyId &&
        an.annotatorId === session?.investigatorId &&
        an.stageId === session?.stageId &&
        an.reconciled === session?.reconciliation
      );
    })
  ),
  on(
    stageActions.sessionSaved,
    stageStudyActions.receivedStageStudy,
    (state, props) =>
      mergeEntityState(entityKey.annotations, state, props, true)
  ),
  on(
    stageActions.saveSession,

    (state, props) =>
      props.correlationId !== undefined
        ? state
        : normalizeAndMergeEntity(
            entityKey.annotations,
            state,
            props,
            studyOutgoingDtoSchema,
            (an) => {
              const pl = props;
              return (
                an.studyId === pl.studyId &&
                an.annotatorId === pl.session?.investigatorId &&
                an.reconciled === pl.reconciliation
              );
            }
          )
  ),
  on(
    stageActions.deleteSession,

    (state, props) =>
      props.correlationId !== undefined
        ? state
        : normalizeAndRemoveEntities(
            entityKey.annotations,
            state,
            props,
            studyOutgoingDtoSchema
          )
  ),
  on(stageActions.commitSessionDeletion, (state, props) =>
    removeEntitiesByFilter(
      state,
      (annotation) =>
        annotation.projectId === props.projectId &&
        annotation.studyId === props.studyId &&
        annotation.stageId === props.stageId &&
        annotation.annotatorId === props.session.investigatorId &&
        annotation.reconciled === props.reconciliation
    )
  )
);
